export const PASSWORD_MIN_LENGTH = 15
export const PASSWORD_MAX_LENGTH = 128

const commonPasswords = new Set([
  '123456789012345',
  'qwertyuiopasdfg',
  'passwordpassword',
  'salasanasalasana',
  'adminadminadmin',
  'hexacathexacat'
])

export const validateNewPassword = (password: string, confirmation: string): string | null => {
  if (!password && !confirmation) return null

  const length = Array.from(password).length
  if (length < PASSWORD_MIN_LENGTH) return `Salasanassa pitää olla vähintään ${PASSWORD_MIN_LENGTH} merkkiä.`
  if (length > PASSWORD_MAX_LENGTH) return `Salasanassa saa olla enintään ${PASSWORD_MAX_LENGTH} merkkiä.`
  if (commonPasswords.has(password.trim().toLocaleLowerCase('fi-FI'))) return 'Salasana on liian yleinen.'
  if (password !== confirmation) return 'Salasanat eivät täsmää.'
  return null
}

export const passwordStrengthLabel = (password: string): { label: string, color: string } | null => {
  if (!password) return null
  const length = Array.from(password).length
  if (length < PASSWORD_MIN_LENGTH) return { label: 'Liian lyhyt', color: 'text-red-600' }
  if (length < 20) return { label: 'Hyvä', color: 'text-emerald-600' }
  return { label: 'Vahva', color: 'text-emerald-700' }
}
